import { Link, Outlet } from "@tanstack/react-router";
import { BookOpen, LayoutDashboard, ScrollText, UploadCloud, Users } from "lucide-react";

const items = [
  { to: "/console", label: "Visão geral", icon: LayoutDashboard, exact: true },
  { to: "/console/usuarios", label: "Usuários", icon: Users, exact: false },
  { to: "/console/cursos", label: "Cursos", icon: BookOpen, exact: false },
  { to: "/console/envios", label: "Enviar aulas", icon: UploadCloud, exact: false },
  { to: "/console/auditoria", label: "Auditoria", icon: ScrollText, exact: false },
] as const;

export function AdminLayout() {
  return (
    <div className="grid gap-6 md:grid-cols-[200px_minmax(0,1fr)]">
      <nav aria-label="Console" className="flex gap-1 overflow-x-auto md:flex-col">
        <p className="hidden px-3 pb-2 text-xs font-semibold tracking-wide text-muted uppercase md:block">Console</p>
        {items.map(({ to, label, icon: Icon, exact }) => (
          <Link
            key={to}
            to={to}
            activeOptions={{ exact }}
            className="flex shrink-0 items-center gap-2 rounded-md px-3 py-2 text-sm text-muted hover:bg-raised hover:text-fg data-[status=active]:bg-raised data-[status=active]:text-fg"
          >
            <Icon className="h-4 w-4" aria-hidden />
            {label}
          </Link>
        ))}
      </nav>
      <div className="min-w-0">
        <Outlet />
      </div>
    </div>
  );
}
